import { render, staticRenderFns } from "./SalesInfo.vue?vue&type=template&id=5a3827d0&scoped=true&"
import script from "./SalesInfo.vue?vue&type=script&lang=js&"
export * from "./SalesInfo.vue?vue&type=script&lang=js&"
import style0 from "./SalesInfo.vue?vue&type=style&index=0&id=5a3827d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3827d0",
  null
  
)

export default component.exports